/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useRef, useState } from 'react';
import { InstantSearch, Index, Hits, Configure, connectStateResults } from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import { HitsWrapper } from '../Hits';
import config from '../../../../config';
import { PageHit } from './hitComps';
import SearchStatus from '../Status';
import Pagination from './pagination';
import Stats from './stats';
import AlgoliaSearchInput from '../Input';
import { onMd, onSm } from '../../../styles/responsive';
import { colors, fancyBorder, prettyScrollBar } from '../../../theme';
import { useOuterClick } from '../../../utils/misc';

const Root = () => (
  <div
    css={{
      position: 'relative',
      display: 'grid',
      gridGap: '1em',
      [onMd]: {
        width: '100%'
      }
    }}
  />
);

const Results = connectStateResults(({ searching, searchState: state, searchResults: res }) => {
  return (
    // @ts-ignore
    <SearchStatus noHits={res && res.nbHits === 0} searching={searching} query={state.query} />
  );
});

const algoliaClient = algoliasearch(
  config.features.search.algoliaAppId,
  config.features.search.algoliaApiKey,
  config.features.search.algoliaSearchKey
);

let isFirstLoad = true;
const { indexName } = config.features.search;

const AlgoliaSearch = ({ showOnSm, rootCss }: { showOnSm?: boolean; rootCss?: any }) => {
  const inputRef = useRef(null);
  const [query, setQuery] = useState(null);
  // const [areResultsCleaned, setAreResultsCleaner] = useState(false);
  // const [isFocused, setIsFocused] = useState(false);
  const [isResultListOpen, setIsResultListOpen] = useState(false);

  const searchRef = useOuterClick(() => {
    setIsResultListOpen(false);
  });
  // const showResults = query.length > 1 && isFocused;
  const showResults = !!query;
  const searchClient = {
    search(requests) {
      if (isFirstLoad) {
        isFirstLoad = false;
        return;
      }
      return algoliaClient.search(requests);
    }
  };

  return (
    <div
      css={{
        [onSm]: {
          display: showOnSm ? 'block' : 'none'
        },
        ...(rootCss || {})
      }}
      ref={searchRef}
    >
      <InstantSearch
        searchClient={searchClient}
        indexName={indexName}
        onSearchStateChange={(data) => {
          setQuery(data.query);
        }}
        root={{ Root, props: { ref: searchRef } }}
      >
        <div css={{ position: 'relative' }}>
          <AlgoliaSearchInput
            inputRef={inputRef}
            onFocus={() => {
              setIsResultListOpen(true);
            }}
            onClean={() => {
              setIsResultListOpen(false);
            }}
          />
          {showResults && (
            <div
              css={{
                display: isResultListOpen ? 'inherit' : 'none',
                position: 'absolute',
                top: '55px',
                right: '0px',
                listStyle: 'none',
                background: colors.background,
                width: '430px',
                maxHeight: '750px',
                overflowY: 'scroll',
                zIndex: 10000,
                ...fancyBorder,
                ...prettyScrollBar
              }}
            >
              <Stats />
              <Results />
              <HitsWrapper>
                <Index key={indexName} indexName={indexName}>
                  <Hits hitComponent={PageHit} />
                </Index>
              </HitsWrapper>
              <Pagination
                totalPages={config.features.search.pagination.totalPages}
                showPrevious={config.features.search.pagination.showPrevious}
                showNext={config.features.search.pagination.showNext}
              />
              <Configure
                hitsPerPage={config.features.search.hitsPerPage}
                attributesToSnippet={[`excerpt:${config.features.search.snippetLength}`]}
                snippetEllipsisText="..."
              />
            </div>
          )}
        </div>
      </InstantSearch>
    </div>
  );
};

export default AlgoliaSearch;
